import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import { releaseStaticRouteHead } from "@/lib/seoHead";
import { isPublicPilotPath } from "../scripts/lib/pilotPolicy";

// Initialize GA4 once at startup. The measurement ID comes from the
// Google Analytics connector public env var.
releaseStaticRouteHead(document);
const root = document.getElementById("root");
const pathname = window.location.pathname;
if (root && isPublicPilotPath(pathname)) {
  // Never read search/hash/cookies/storage or initialize the protected App tree.
  import("./public-pilot/PublicTree").then(({ default: PublicTree }) => {
    const tree = <PublicTree pathname={pathname} />;
    if (root.dataset.publicPilot === pathname) hydrateRoot(root, tree);
    else createRoot(root).render(tree);
  });
} else if (root) {
  Promise.all([import("./App.tsx"), import("@/lib/analytics")]).then(([{ default: App }, { initAnalytics }]) => {
    initAnalytics();
    createRoot(root).render(<App />);
  });
}
